import { FileUrl, InvestmentBoxData, LogoData, NavlinkData, refURL } from "../hooks/useApiCalls";

import { useWeb3Modal } from '@web3modal/wagmi/react'
import toast, { Toaster } from "react-hot-toast";
import { useAccount } from 'wagmi'
// import { EarnedRefBalance, IsRef, RefPercent } from "../hooks/useReadPresale";

function Navbar() {

    const logodata = LogoData();
    const navlinks =  NavlinkData();

    const { open } = useWeb3Modal();
    const { address, isConnected } = useAccount();

    const datas = InvestmentBoxData();
    const networkInfo = datas.network ? datas.network : {};

    

    const shortAddr = (addr) =>{
        return(((addr).substring(0, 8) + "..." + (addr).substring((addr).length - 4)));
    }

    const ConnectWalletOnclick = ()=>{
        open();
      }
      
    
     /* const isRef = IsRef();
      const rPercent = RefPercent();
      const earnedRef = EarnedRefBalance(address)/1e18; */ 

      const isRef = false;
      const rPercent = 0;
      const earnedRef = 0; 
 
      
    return ( 
       <>

        <Toaster
		     position="top-right"
		     reverseOrder={false}
	    	/>
       
        <nav className="navbar navbar-expand-lg">
                <div className="container">
                    <img width={50} src={FileUrl("images/"+logodata.logo)} /> 
                    
               {/*} <a className="navbar-brand" href="#">CryptoSale</a> {*/}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                    {navlinks.map((data)=>{
                         return <li className="nav-item"><a className="nav-link" href={data.link}>{data.text}</a></li>;
                    })}

                    {isRef == "true" ? <>
                        <li className="nav-item">
                        <button data-bs-toggle="modal" data-bs-target="#refModal"  className="btn btn-connect-yellow"><i className="fas fa-users" /> Reference System</button>
                    </li>
                    </> : ""}
                    
                    <li className="nav-item">
                        <button onClick={ConnectWalletOnclick} className="btn btn-connect-yellow"><i className="fas fa-wallet" /> {isConnected ? shortAddr(address) : "Connect Wallet"}</button>
                    </li>

                    </ul>
                </div>
                </div>
            </nav>

            {isRef == "true" ? <><div className="modal fade" id="refModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" >
                  <div className="modal-content" style={{border:"solid 1px var(--color-card-border-hover)",backgroundColor:"var(--color-card-background)"}}>
                    <div className="modal-header text-light">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">Reference Detail</h1>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body text-light">

                        {isConnected ? <>

                            Reference Bonus:  <b>{rPercent}%</b> 
                                <br/>
                                Earned Bonus: <b>{earnedRef} {networkInfo.symbol} </b>
                                <br/><br/>
                                
                                <div className="input-group mb-3">
                                    <input type="text"  value={refURL(address)} className="form-control" placeholder="Reference Link" aria-label="Reference Link" aria-describedby="button-addon2" readOnly />
                                    <button className="btn btn-primary" onClick={()=>{navigator.clipboard.writeText(refURL(address)); toast.success("Url Copied")}} style={{padding:"13px",width:"100px"}} type="button" id="button-addon2"><i className="fas fa-copy" /> Copy</button>
                                </div>

                        </> : <><div className="alert alert-warning"> Connect wallet to get your referral link.         </div></>}

                        <p>
                            If you invite through the referral program, <b>{rPercent}%</b> {networkInfo.symbol} of the amount received will automatically be transferred to your account when a purchase is made through your link. 
                        </p>
                    
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div></> : ""}

            

       </> 
 ); 

} 

export default Navbar;